import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { IdentityVerificationResultStateHelper, PendingAgreementType, SsoAccountData, SsoAccountFacade } from 'common';
import { IdentityNavigationService } from '../../services/identity-navigation.service';

@Injectable()
export class VerifyIdentityFacade {
  constructor(
    private readonly router: Router,
    private readonly ssoAccountFacade: SsoAccountFacade,
    private readonly identityNavigationService: IdentityNavigationService
  ) { }

  handleVerifyIdentitySuccessRedirect(currentAccount: SsoAccountData): void {
    this.ssoAccountFacade.clearSsoAccountCache();
    if (currentAccount?.nextAgreementToSign?.type === PendingAgreementType.Application) {
      this.identityNavigationService.signApplicationAgreement({ applicationId: currentAccount.nextAgreementToSign.id })
    }
    else {
      this.router.navigate(['dashboard']);
    }
  }

  handleIdVerseFailedRedirect(isExpired: boolean): void {
    IdentityVerificationResultStateHelper.set({
      title: isExpired ? 'Verification expired' : 'Verification unsuccessful',
    });

    if(isExpired) {
      this.router.navigate(['account/setup/verify-identity-result'], { 
        replaceUrl: true,
      });
    } 
    else {
      this.router.navigate(['account/setup/verify-identity-result']);
    }
  }
}